import { FC, useEffect, useState, useContext, createContext } from "react";
import { isLoggedIn, saveToken } from "../services/CookieHandler";
import { LoginDialog } from "./LoginDialog";
import { Container, Group, Burger, Button, Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import classes from '../HeaderSimple.module.css'
import { create } from 'zustand'
import { fetchAsync } from "../services/ApiHandler";
import { RemainCountResponse } from "../model/RemainCountResponse";
import { Subscription } from "../model/Subscription";
import { getNextPlanId, getPlanName, getPlanNameBySubscription } from "../services/SubscriptionService";
import { StripeCard } from "../model/StripeCard";
import { SetupIntentResponse } from "../model/SetupIntentResponse";
import { Account } from "../model/Account";
import { removeToken } from "../services/CookieHandler";
import { SubscriptionDialog, SubscriptionDialogProps } from "./SubscriptionDialog";
import { GenerationCreditDialog, GenerationCreditDialogProps } from "./GenerationCreditDialog";
import { toast, Toaster } from "react-hot-toast";
import { CardRegistrationDialog } from "./CardRegisterDialog";
import { CardRegistrationDialogProps } from "./CardRegisterDialog";
import { ProfileImage } from "../model/ProfileImage";
import { getProfileImageUrl } from "../services/ProfileImageUtil";

interface HeaderState {
  remainCount: number
  subscription: Subscription | undefined
  card: StripeCard | undefined
  clientSecret: string | undefined
  isLoggedIn: boolean
  account: Account | undefined
  profileImage: ProfileImage | undefined
  screenWidth: number
  
  setRemainCount: (by: number) => void
  setSubscription: (by: Subscription | undefined) => void
  setCard: (by: StripeCard | undefined) => void
  setClientSecret: (by: string) => void
  setIsLoggedIn: (by: boolean) => void
  setAccount: (by: Account | undefined) => void
  setScreenWidth: (by: number) => void
  setProfileImage: (by: ProfileImage | undefined) => void
  fetchCard: () => Promise<void>
  fetchRemainCount: () => Promise<void>
  fetchActiveSubscription: () => Promise<void>
  // fetchClientSecret: () => Promise<void>
  fetchAccount: () => Promise<void>
  fetchProfileImage: () => Promise<void>
  onLogin?: () => void;
}

export const useHeaderStore = create<HeaderState>()((set) => ({
  remainCount: 0,
  subscription: undefined,
  card: undefined,
  clientSecret: undefined,
  isLoggedIn: isLoggedIn(),
  account: undefined,
  screenWidth: window.innerWidth,
  profileImage: undefined,
  
  setClientSecret: (by) => set((state) => ({ clientSecret: by })),
  setIsLoggedIn: (by) => set((state) => ({ isLoggedIn: by })),
  setRemainCount: (by) => set((state) => ({ remainCount: by })),
  setSubscription: (by) => set((state) => ({ subscription: by })),
  setCard: (by) => set((state) => ({ card: by })),
  setAccount: (by) => set((state) => ({ account: by })),
  setProfileImage: (by) => set((state) => ({ profileImage: by })),

  fetchCard: async () => {
    const response = await fetchAsync<StripeCard[]>('Stripe/GetActiveCard');
    if(response.length >= 1) {
      set((state) => ({ card: response[0] }));
    }
  },
  fetchRemainCount: async () => {
    const response = await fetchAsync<RemainCountResponse>('Generation/GetRemainCount');
    set((state) => ({ remainCount: response.remainCount }));
  },
  fetchActiveSubscription: async () => {
    const response = await fetchAsync<Subscription>('Subscription/GetActiveSubscription');
    set((state) => ({ subscription: response }));
  },
  /*
  fetchClientSecret: async () => {
    const response = await fetchAsync<SetupIntentResponse>('Stripe/GetSetupIntent');
    set((state) => ({ clientSecret: response.clientSecret }));
  },*/
  fetchAccount: async () => {
    const response = await fetchAsync<Account>('Account/GetAccountInfo');
    set((state) => ({ account: response }));
  },
  fetchProfileImage: async () => {
    const response = await fetchAsync<ProfileImage>('Account/GetProfileImage');
    set((state) => ({ profileImage: response }));
  },
  setScreenWidth: (by) => set((state) => ({ screenWidth: by })),
}))

export const CommonHeader: FC = (props) => {
  // const [loginFlag, setLoginFlag] = useState(props.isLoggedIn);
  const [loginDialogVisible, setLoginDialogVisible] = useState(false);
  const {
    isLoggedIn, setIsLoggedIn,
    remainCount, setRemainCount,
    subscription, setSubscription,
    card, setCard,
    account, setAccount,
    screenWidth, setScreenWidth,
    onLogin,
    profileImage, setProfileImage,
    fetchCard, fetchRemainCount, fetchActiveSubscription, fetchAccount, fetchProfileImage,
  } = useHeaderStore();

  const links = [
    { link: '/image-generation', label: '画像生成' },
    { link: '/inspiration', label: 'インスピレーション' },
    { link: '/', label: 'Drop AI とは' },
    { link: '/plan', label: 'プラン' },
    { link: '/article/help/', label: 'ヘルプ' },
  ];
  
  useEffect(() => {
    if (isLoggedIn) {
      fetchRemainCount();
      fetchActiveSubscription();
      fetchCard();
      fetchAccount();
      fetchCard();
      fetchProfileImage();
      setScreenWidth(window.innerWidth);
    }
  }, [])
  
  async function onLoginEvent() {
     window.location.reload();
  }

  const [opened, { toggle }] = useDisclosure(false);
  const [active, setActive] = useState(links[0].link);
  const [loginDialogOpened, { open: openLoginDialog, close: closeLoginDialog }] = useDisclosure(false);
  const [spMenuDialogOpened, { open: openSpMenuDialog, close: closeSpMenuDialog }] = useDisclosure(false);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [generationCreditDialogProps, setGenerationCreditDialogProps] = useState<GenerationCreditDialogProps | undefined>(undefined);
  const [subscriptionDialogOpened, { open: openSubscriptionDialog, close: closeSubscriptionDialog }] = useDisclosure(false);
  const [subscriptionDialogProps, setSubscriptionDialogProps] = useState<SubscriptionDialogProps | undefined>(undefined);
  const [creditDialogOpened, { open: openCreditDialog, close: closeCreditDialog }] = useDisclosure(false);
  const [cardProps, setCardProps] = useState<CardRegistrationDialogProps | undefined>(undefined);

  function toggleSpMenuDialog() {
    toggle();
    if (spMenuDialogOpened) {
      closeSpMenuDialog();
    } else {
      openSpMenuDialog();
    }
  }

  function onCloseSpMenuDialog() {
    closeSpMenuDialog();
    toggle();
  }

  function buildMenu(text: string, link: string){
    return (
      <a href={link}>
        <div className="flex items-center mt-5 ml-2 justify-between">
          <span>{text}</span>
          <img className="h-[20px] mr-2" src="/images/icon/icon-right.svg"></img>
        </div>
      </a>
    )
  }

  function logout() {
    removeToken();
    window.location.href = '/image-generation'
  }

  function onClickSignupLink(){
    setIsLoginMode(false);
    closeSpMenuDialog();
    openLoginDialog();
    toggle();
  }

  function onClickLoginLink(){
    setIsLoginMode(true);
    closeSpMenuDialog();
    openLoginDialog();
    toggle();
  }
  
  function onClickUpgradePlan() {
    setGenerationCreditDialogProps(undefined);
    if(card === undefined) {
      // fetchClientSecret();
      return;
    }
    const nextPlanId = getNextPlanId(subscription);
    setSubscriptionDialogProps({
      planId: nextPlanId
    } as SubscriptionDialogProps);
    openSubscriptionDialog();
  }

  function onClickCreditPurchase(){
    setGenerationCreditDialogProps({
      onPurchase: () => {
        toast.success("購入しました");
        setGenerationCreditDialogProps(undefined);
      }
    } as GenerationCreditDialogProps);
    openCreditDialog();
  }


  const items = links.map((link) => (
    <a
      key={link.label}
      href={link.link}
      className={classes.link}
      style={{ color: '#03034F' }}
      onClick={(event) => {
        window.location.href = link.link;
      }}
    >
      {link.label}
    </a>
  ));

  return (
    <>
    <Toaster />
    <Modal size="auto" opened={loginDialogOpened} onClose={closeLoginDialog} yOffset="15dvh">
      <LoginDialog onCancel={() => setLoginDialogVisible(false)} onLogin={() => onLogin === undefined ? onLoginEvent() : onLogin() } isLogin={isLoginMode} />
    </Modal>

    { cardProps !== undefined &&
    <CardRegistrationDialog clientSecret={cardProps?.clientSecret!} onClose={() => setCardProps(undefined)} />
    }

    { generationCreditDialogProps !== undefined &&
    <Modal padding={0} size="auto" opened={creditDialogOpened} onClose={closeCreditDialog} closeButtonProps={{ className: 'mr-3' }}>
      <GenerationCreditDialog
        onPurchase={() => setGenerationCreditDialogProps(undefined)}
        onCancel={() => setGenerationCreditDialogProps(undefined)}
        onUpgrade={onClickUpgradePlan}
        />
    </Modal>
    }

    { subscriptionDialogProps !== undefined &&
    <Modal size="auto" opened={subscriptionDialogOpened} onClose={closeSubscriptionDialog}>
      <SubscriptionDialog onPurchase={() => setSubscriptionDialogProps(undefined)} onCancel={() => setSubscriptionDialogProps(undefined)} planId={subscriptionDialogProps?.planId} />
    </Modal>
    }
  

    <Modal fullScreen size="auto" opened={spMenuDialogOpened} onClose={() => onCloseSpMenuDialog()}>
      <img className="mr-2 absolute w-[100px] left-[20px] top-[16px]" style={{ zIndex: 1000}} src="/images/drop-ai-logo.png"></img>
      { !isLoggedIn &&
      <div className="gradient-border mt-2">
        <div className="flex justify-between items-center gradient-content" onClick={onClickSignupLink}>
          <div className="ml-3 py-2">
            <div className="text-sm text-gray-500">DROP AIを体験してみましょう</div>
            <div className="gradation-text font-bold text-lg">無料アカウント登録</div>
          </div>
          <div>
            <img src="/images/icon/icon-right.svg" className="h-[20px] mr-2"></img>
          </div>
        </div>
        </div>
      }
      <a href="/image-generation">
        <div className="flex items-center mt-4 ml-2">
          <img className="h-[20px] mr-2" src="/images/icon/icon-flare-color.svg"></img>
          <span className="text-lg gradation-text font-bold">画像生成</span>
        </div>
      </a>
      <a href="/inspiration">
        <div className="flex items-center mt-4 ml-2">
          <img className="h-[20px] mr-2" src="/images/icon/bulb.svg"></img>
          <span className="text-lg">インスピレーション</span>
        </div>
      </a>
      <div className="bg-gray-300 h-[1px] w-full mt-4"></div>
      { !isLoggedIn &&
      <div className="mt-4 rounded flex items-center py-2 pl-2 justify-between bg-[#EAEAFF] clickable" onClick={onClickLoginLink}>
        <span className="flex items-center">
          <img className="h-[20px] mr-2" src="/images/icon/icon-user.svg"></img>
          <span>ログインする</span>
        </span>
        <img className="h-[20px] mr-2" src="/images/icon/icon-right.svg"></img>
      </div>
      }
      { isLoggedIn &&
        <>
        <div className="flex mb-4 mt-2 ml-2 items-center">
            <img src="/images/icon/no-image.svg" className="h-[30px] w-[30px] mr-2" />
            <span className="text-sm text-gray-500">{account?.email}</span>
        </div>
        <div className="flex">
          <div className="mb-4 w-[50%] justify-between items-center text-sm border rounded-lg p-2">
            <div className="text-xs text-gray-500">現在のプラン</div>
            <div className="font-bold">{getPlanNameBySubscription(subscription)}</div>
            { (subscription?.internalProductId === 'free' || subscription?.internalProductId.startsWith('lite')) &&
            <div onClick={onClickUpgradePlan} className="text-xs clickable font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#0000F3] to-[#F416BF]">プランをアップグレード</div>
            }
          </div>

          <div className="mb-4 ml-2 w-[50%] justify-between items-center text-sm border rounded-lg p-2">
            <div>
              <div className="text-xs text-gray-500">残り生成回数</div>
              <div>
                <span className="font-bold mr-1">{remainCount}</span>
                <span className="text-gray-500 text-sm">回</span>
              </div>
            </div>
            { (subscription?.internalProductId === 'lite' || subscription?.internalProductId.startsWith('standard')) &&  
            <div className="clickable" onClick={onClickCreditPurchase}>生成回数を追加 +</div>
            }
          </div>
        </div>
        { buildMenu("生成履歴", "/generation-history") }
        { buildMenu("お支払い", "/subscription") }
        </>
      }
      { buildMenu("Drop AIとは", "/") }
      { buildMenu("プラン", "/plan") }
      { buildMenu("ヘルプ", "/article/help/") }
      
      <div style={{ height: 20 }}></div>
      <div className=" w-full text-gray-500">
        <div className="flex">
          <a className="text-sm mr-4" href="/help">ヘルプ</a>
          <a className="text-sm mr-4" href="/">利用規約</a>
          <a className="text-sm" href="/privacy-policy">プライバシーポリシー</a>
        </div>
        <div className="text-sm mt-4 mb-6 text-gray-500">
          <span className="clickable" onClick={logout}>ログアウト</span>
        </div>
        <div className="bg-gray-300 h-[1px] w-full mt-4"></div>
        <div className="text-sm mt-2 mb-4 text-gray-500">
          GO TO MARKET, inc. All Rights. Reserved.
        </div>
      </div>
    </Modal>
  
    <header className={`${classes.header}`}>
      <Container size="md" className={classes.inner}>
        <a href={ window.location.pathname === '/' ? '/' : '/image-generation'}>
          <img src="/images/drop-ai-logo.png" className="h-[30px] ml-4 pr-2"></img>
        </a>
        <Group gap={5} visibleFrom="xs">
          {items}
          { isLoggedIn === true &&
            <a href="/account">
             <div className="flex rounded-md border border-gray-300 py-1 px-2 items-center">
              <img src={getProfileImageUrl(profileImage)} className="h-[30px] w-[30px] mr-2 rounded-full"/>
              <div className="ml-2">
                <div className="text-sm font-bold">{getPlanNameBySubscription(subscription)}プラン</div>
                <div className="text-sm text-gray-500">
                  <span className="mr-2">残り生成数</span>
                  <span className="w-[40px] inline-block">{remainCount}</span>
                </div>
              </div>
             </div>
            </a>
          }
          { isLoggedIn === false &&
             <Button onClick={onClickLoginLink} className="gradation-button ml-6" style={{fontWeight: '700'}}>ログイン</Button>
          }
        </Group>

        <Burger opened={opened} onClick={toggleSpMenuDialog} hiddenFrom="xs" size="sm" />
        
      </Container>
    </header>
    </>
  );

}